import { formatMoney } from "@/lib/format";

/* Money for display while editing. The API recomputes every amount with Decimal. */

/** Quantity × rate in cents, rounded half up like the server; 0 for an invalid quantity. */
export function lineCents(qty: string, rate: string): number {
  const quantity = Number(qty);
  const rateCents = Math.round(Number(rate) * 100);
  if (!Number.isFinite(quantity) || quantity <= 0 || !Number.isFinite(rateCents)) return 0;
  return Math.round(quantity * rateCents);
}

/** 140000 → "1400.00", the API's money string format. */
export function centsToAmount(cents: number): string {
  return (cents / 100).toFixed(2);
}

/** Money strings summed per currency, currencies in alphabetical order. */
export function totalsByCurrency<T>(
  rows: T[],
  currency: (row: T) => string,
  amount: (row: T) => string,
): { currency: string; amount: string }[] {
  const cents = new Map<string, number>();
  for (const row of rows) {
    const code = currency(row);
    cents.set(code, (cents.get(code) ?? 0) + Math.round(Number(amount(row)) * 100));
  }
  return [...cents.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([code, total]) => ({ currency: code, amount: centsToAmount(total) }));
}

/** "USD 1,400.00 + SAR 5,250.00", or an em dash when there is nothing. */
export function formatTotals(totals: { currency: string; amount: string }[]): string {
  if (totals.length === 0) return "—";
  return totals.map((total) => formatMoney(total.amount, total.currency)).join(" + ");
}
